const Separator = ({ text }) => {
	return (
		<div className="d-flex justify-content-center mt-2">
			<hr style={ {marginTop: '.75em', width: '100%' } } />
			<span className="mx-2">{text}</span>
			<hr style={ {marginTop: '.75em', width: '100%' } } />
		</div>
	)
};
export default Separator;